var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"height-100dvh"},[_c('header',{staticClass:"mob-back-header"},[_c('img',{staticClass:"mr-3",attrs:{"src":require("../assets/mobile/assprog/mobileBackArrow.svg"),"alt":""},on:{"click":function($event){return _vm.$router.go(-1)}}}),_vm._v(" Become Instructor ")]),_c('BecomeInstructorForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }